import React, { useEffect, useState } from "react";
import { WALLET_TRANSACTION_STATUS } from "../wallet.constant";
import { Network } from "../../../utils/network";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import {Color, globalFontStyle} from "../../../assets";
import {useFocusEffect, useNavigation} from "@react-navigation/native";
import FastImage from "../../../common/FastImage";
import {kyc_pending, kyc_process, kyc_success} from "../../../utils/images";
import {isMobile} from "../../../utils/commonMethods";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData, globalConst, GlobalScreens} from "../../../utils/globalConstant";

const WalletLastTxnStatus = () => {
  let navigation= useNavigation();
  const [txnStatus, setTxnStatus] = useState(null);
  const getStatus = async () => {
    const res = await Network.getLastTxnStatus();
    if (
      res?.data?.success &&
      res?.data?.paymentStatus &&
      res?.data?.paymentStatus.length > 0
    ) {
      setTxnStatus(res.data?.paymentStatus[0]);
    } else {
    }
  };

  const cTA = txnStatus?.title === 'KYC Failed' ? 'Retry'
      : txnStatus?.title === 'No Bank Account Found' ? 'Add bank account'
      : txnStatus?.title === 'KYC Pending' ? 'Complete KYC' : null;

  useFocusEffect(
    React.useCallback(() => {
      getStatus();
    }, [])
  );

  return (
    <>
      {txnStatus && globalConst.partnerId===1 && (
        <View
          style={[
            styles.investedContainer,
            {
              backgroundColor: WALLET_TRANSACTION_STATUS[txnStatus?.status]?.color,
              borderColor: WALLET_TRANSACTION_STATUS[txnStatus?.status]?.borderColor,
            },
          ]}
        >
          <FastImage
            style={styles.txnStyle}
            source={(txnStatus?.title === 'KYC Pending' || txnStatus?.title === 'KYC Under Review') ?
                kyc_process() : (txnStatus?.title === 'KYC Successful') ? kyc_success() :
                    WALLET_TRANSACTION_STATUS[txnStatus?.status]?.icon()}
          />
          <View style={styles.contentContainer}>
            <Text
              style={[
                styles.statusTitle,
                {
                  color: WALLET_TRANSACTION_STATUS[txnStatus?.status]?.colorText,
                },
              ]}
            >
              {txnStatus?.title}
            </Text>
            <Text style={styles.statusTxt}>
              {txnStatus?.message}
            </Text>
            {cTA && (
              <FormTextLabel
                onPress={() => {
                  if (txnStatus?.title === 'Profile Incomplete') {
                    navigation.navigate('Profile');
                  } else {
                    navigation.navigate('manageKycBank', {
                      showKYC: true
                    });
                  }
                }}
                label={cTA}
                labelStyles={styles.actionButton}
              />
            )}
          </View>
        </View>
      )}
    </>
  );
};

export default WalletLastTxnStatus;

const styles = StyleSheet.create({
  txnStyle: {
    width: 24,
    height: 24,
    marginRight: 12,
    marginTop: 2,
  },
  statusTxt: {
    ...globalFontStyle.appFontSmallText,
    flex: 1,
    marginTop: 6,
    color: globalConfigurableData.secondaryTextColor1,
  },
  statusTitle: {
    ...globalFontStyle.appFontSubTextBold,
    flex: 1,
    marginTop: -2,
  },
  actionButton: {
    ...globalFontStyle.appFontSmallTextBold,
    color: globalConfigurableData.primaryBtnColor,
    textDecorationLine: "underline",
    marginTop: 8,
  },
  investedContainer: {
    marginTop: 20,
    backgroundColor: "rgba(168, 32, 13, 0.1)",
    borderWidth: 1,
    borderColor: "#A8200D",
    flexDirection: "row",
    paddingHorizontal: 16,
    paddingVertical: 12,
    alignItems: "flex-start",
    borderRadius: 8,
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'flex-start',
  }
});
